export class Forminator {

    constructor()
    {

        this.textarea = document.querySelector('.forminator-textarea');
        this.formulaire = document.querySelector('#forminator-module-13');
        this.error_div = document.querySelector('.forminator-response-message');
        this.select_2_container = document.querySelector('#select-2');
        this.title_wrapper_2 = document.querySelector('.title_wrapper_2'); 

        // Select input
        this.select_1 = document.querySelector('.select_option_1').querySelector('.forminator-select--field');
        this.select_2 = document.querySelector('.select_option_2').querySelector('.forminator-select--field');

        // All Forminator Input wrapper
        this.text_1_wrapper = document.querySelector('#text-1').closest('.forminator-row');
        this.textarea_wrapper = document.querySelector('#textarea-1').closest('.forminator-row');
        this.select_1_wrapper = document.querySelector('#select-1').closest('.forminator-row');
        this.select_2_wrapper = document.querySelector('#select-2').closest('.forminator-row');
        this.email_wrapper = document.querySelector('#email-1').closest('.forminator-row');
        this.phone_wrapper = document.querySelector('#phone-1').closest('.forminator-row');
        this.url_wrapper = document.querySelector('#url-1').closest('.forminator-row');
        this.upload_wrapper = document.querySelector('#upload-1').closest('.forminator-row');

        //-- Add One row and Tow columns inside the form --//

        this.all_fields_wrapper = document.createElement('div');
        this.all_fields_wrapper.className = 'all_fields_wrapper';

        this.fields_wrapper_col_1 = document.createElement('div');
        this.fields_wrapper_col_1.className = 'fields_wrapper_col_1';

        this.fields_wrapper_col_2 = document.createElement('div');
        this.fields_wrapper_col_2.className = 'fields_wrapper_col_2';

        // Add input into new Element
        this.fields_wrapper_col_1.appendChild(this.text_1_wrapper);
        this.fields_wrapper_col_1.appendChild(this.select_1_wrapper);
        this.fields_wrapper_col_1.appendChild(this.select_2_wrapper);
        this.fields_wrapper_col_1.appendChild(this.email_wrapper);
        this.fields_wrapper_col_1.appendChild(this.phone_wrapper);
        this.fields_wrapper_col_1.appendChild(this.url_wrapper);

        this.fields_wrapper_col_2.appendChild(this.textarea_wrapper);
        this.fields_wrapper_col_2.appendChild(this.upload_wrapper);

        this.formulaire.insertBefore(this.all_fields_wrapper, this.error_div);

        this.all_fields_wrapper.appendChild(this.fields_wrapper_col_1)
        this.all_fields_wrapper.appendChild(this.fields_wrapper_col_2)

        this.clone_title_wrapper_2 = this.title_wrapper_2.cloneNode(true);
        this.clone_title_wrapper_2.className = 'title_wrapper only_mobile';
        this.all_fields_wrapper.insertBefore(this.clone_title_wrapper_2, this.fields_wrapper_col_2);

        //-- Add One element below the second select input --//

        this.alert_message = document.createElement('p');
        this.alert_message.className = 'alert_message';
        this.select_2_container.appendChild(this.alert_message)

        this.change()

        this.message = {
            'option_1': '--> Détail du problème :  \n   \n --> Lien URL de la page concernée : \n   \n --> Navigateur utilisé :   \n   \n --> Date et heure du dysfonctionnement concerné :',
            'option_2': '--> Je souhaite comprendre ce point dans l’outil que vous m’avez développé : \n   \n --> Mon navigateur :  \n   \n --> Le compte que j’utilise pour me connecter :',
            'option_3': '--> Je souhaite améliorer ce point sur mon outil : \n   \n --> Comportement actuel de l’outil :  \n   \n --> Comportement que je souhaite mettre en place :',
            'option_4': '--> Je souhaite ajouter / modifier ce contenu (texte ou image) sur mon outil : \n   \n --> Page concernée :',
            'option_5': '--> Je dispose actuellement de l’outil suivant (site, email, accès nom de domaine, etc.) : \n   \n --> Je souhaite récupérer mes accès à l’administration :',
            'option_6': '--> Je vous trouve formidable et je voulais juste vous en faire part en vous envoyant un petit bonjour :',
        }

        this.alert = {
            'option_one': 'Toute utilisation abusive de ce type de demande pourra nécessiter un contrat de maintenance Haute disponibilité, vous serez alors contacté par nos services commerciaux.',
            'option_two': 'Vous reçevrez un message de confirmation dès que nos équipes auront pris en compte votre demande. Le ticket sera traité dès que possible.',
        }

        this.title_wrapper_2

       
    }

    change() {

        let that = this

        jQuery(this.select_1).on('change', function(){

            if(that.select_1.value === 'option_1') that.textarea.value = that.message.option_1
            if(that.select_1.value === 'option_2') that.textarea.value = that.message.option_2
            if(that.select_1.value === 'option_3') that.textarea.value = that.message.option_3
            if(that.select_1.value === 'option_4') that.textarea.value = that.message.option_4
            if(that.select_1.value === 'option_5') that.textarea.value = that.message.option_5
            if(that.select_1.value === 'option_6') that.textarea.value = that.message.option_6

        });

        jQuery(this.select_2).on('change', function(){

            if(that.alert_message.classList.contains('urgence')) that.alert_message.classList.remove('urgence');

            if(that.select_2.value === 'option_one') {
                that.alert_message.classList.add('urgence')
                that.alert_message.textContent = that.alert.option_one;
            } 

            if(that.select_2.value === 'option_two') that.alert_message.textContent = that.alert.option_two;

        });

    }

}



// WEBPACK FOOTER //
// ./js/util/Forminator.js